import { defineStore } from "pinia";
import { computed, reactive } from "vue";

export const useErrorService = defineStore("errorService", () => {
  const state = reactive({
    errors: new Map(), // multiple tracked errors if needed
    order: [],
  });

  const isVisible = computed(() => state.order.length > 0);
  const current = computed(() => {
    const topId = state.order[state.order.length - 1];
    return topId ? state.errors.get(topId) : undefined;
  });

  const title = computed(() => current.value?.title || "An Error Occurred");
  const message = computed(() => current.value?.message || "Unknown error");
  const details = computed(() => current.value?.details || "");

  function show(id, opts = {}) {
    if (!state.errors.has(id)) state.order.push(id);
    state.errors.set(id, { ...opts });
  }

  function update(id, opts = {}) {
    if (!state.errors.has(id)) return;
    const prev = state.errors.get(id) || {};
    state.errors.set(id, { ...prev, ...opts });
  }

  function close(id) {
    if (!state.errors.has(id)) return;
    state.errors.delete(id);
    const idx = state.order.indexOf(id);
    if (idx >= 0) state.order.splice(idx, 1);
  }

  function closeAll() {
    state.errors.clear();
    state.order.splice(0, state.order.length);
  }

  return {
    isVisible,
    title,
    message,
    details,
    show,
    update,
    close,
    closeAll,
  };
});
